import React, { useState, useEffect, useRef } from 'react';
import { 
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Label,
  CustomInput,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,
  InputGroup, InputGroupAddon, InputGroupText
} from 'reactstrap';

import ClientTable from './ConsultationClientTable';
import EncaissementTable from './ConsultationEncaissementTable';
import VEncaissementContainer from '../vente/encaissement/VEncaissementContainer';
import VenteListTable from './ConsultationVenteListTable';
import Association from './Association';
import BienCardInfo from '../bien_card/BienCardInfo';
import DocumentImageModal from './DocumentImageModal';
import RecuRecreation from './RecuRecreation';
import VenteInfo from './VenteInfo';
import { constants } from '../../types/constants';
import { PRIVILEGE } from '../../types/privileges'
import { connect } from 'react-redux';
import { getVenteById, clearVenteCard, getVentesByNumDossier, getVenteIDFromID, getVenteIDFromBienID, getVentesByCIN, getVentesByEnc, addContratSigne, replaceRecu, getRecuImages } from '../../flux/actions/venteActions';
import { getBienById, clearBienCard, getBiensByN } from '../../flux/actions/bienActions';
import { clearEncaissementLines } from '../../flux/actions/encaissementlineActions';
import { getUsers } from '../../flux/actions/userActions';
import { getConstanteProjetInfos } from '../../flux/actions/constanteActions';
import { ConsultationContainer, IConsultationReduxProps, ITableClientLine, ITarget } from '../../types/interfaces';
import Select from 'react-select';
import LoadingPage from '../../pages/loading';
import Loading from '../Loading';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faBuilding, faHashtag, faHouseDamage, faLayerGroup, faMoneyBill, faMoneyBillAlt, faRulerCombined, faThLarge, faCompass, faMap, faQuestionCircle, faSquare, faCheckSquare, faSearch, faBookmark, faMapMarkerAlt, faSignature, faFolder, faFileInvoice, faReceipt, faFileContract, faFilePdf, faSync, faCloudUploadAlt, faHandRock, faTimes, faSpinner, faCheckCircle, faInfoCircle, faPercent, faPen, faCalendarAlt, faFileImage, faBookOpen, faPrint, faFileDownload, faPencilRuler, faCheck, faUsers, faUserCircle, faMoneyCheckAlt, faFileAlt } from '@fortawesome/free-solid-svg-icons'
import { useHistory, useLocation } from 'react-router-dom';
import { useAlert } from "react-alert";
import ReactTooltip from 'react-tooltip';
import moment from "moment";
import PDFLink, { PreviewBase64, printBase64, downloadBase64, instantUploadToFTP, printBuffer } from '../pdf/PDFLink';

import DatePicker from "reactstrap-date-picker";
import { addDocument, getAvailableDocuments, getDocument } from '../../flux/actions/documentActions';
import { useDropzone } from 'react-dropzone';
import { downloadImg, printBase64Image } from '../../services/misc';

const ConsultationContainerComponent = ({ 
  getVenteById,
  clearVenteCard,
  vente,
  getBienById,
  clearBienCard,
  bien,
  consultationOnly,
  isReplacement,
  encaissementline,
  clearEncaissementLines,
  getUsers,
  user,
  addContratSigne,
  auth
 }: ConsultationContainer) => {
  const { info, loading } = vente;
  const { info: bienInfo, loading: loadingB } = bien;
  const { encaissementlines } = encaissementline;
  const { users, loading: loadingU } = user;
  const alert = useAlert();
  const history = useHistory();
  let { id, bienId, ass } = useParams();
  const location = useLocation();
  const [locationFlag, setLocationFlag] = useState(false);
  const [locationFlag2, setLocationFlag2] = useState(false);

  const [activeTab, setActiveTab] = useState(consultationOnly ? constants.TAB_BIEN : constants.TAB_ENCAISSEMENT);
  const userOptions = users.map(e => ({value: e, label: e.username}));
  const [userValue, setUserValue] = useState<any>('');
  const allSocieteValue = {id: "ALL", LIBELE: "Tous les projets"}
  const selectSocieteOptions = [...((auth?.user?.societes || []).length > 1 ? [allSocieteValue] : []), ...(auth?.user?.societes || []).sort((a, b) => (!a.LIBELE && !b.LIBELE) ? 0 : !a.LIBELE ? -1 : !b.LIBELE ? 1 : a.LIBELE.localeCompare(b.LIBELE))].map(e => ({value: e, label: e.LIBELE})) || [];
  const [societeValue, setSocieteValue] = useState<any>('');
  const soldAllValue = {value: "ALL", label: "Tout"}
  const soldOptions = [soldAllValue, {value: "VENTE", label: "Vendus"}, {value: "BIEN", label: "Non Vendus"}];
  const [soldValue, setSoldValue] = useState({value: "VENTE", label: "Vendus"});
  const selectOptionsDefaultValues = [{value: constants.CONSULTATION_SELECT_N_DOSSIER, label: "N° Dossier"}, {value: constants.CONSULTATION_SELECT_ID_CONTRAT, label: "ID Vente Sys"}, {value: constants.CONSULTATION_SELECT_ID_BIEN, label: "ID Bien Sys"}, {value: constants.CONSULTATION_SELECT_CIN, label: "CIN"}, {value: constants.CONSULTATION_SELECT_REF_REG, label: "Réf. Encaissement"}];
  const [selectOptions, setSelectOptions] = useState(selectOptionsDefaultValues);
  const [selectedValue, setSelectedValue] = useState(selectOptionsDefaultValues.find(e => e.value === constants.CONSULTATION_SELECT_N_DOSSIER));
  const [searchValue, setSearch] = useState('');
  const [modal, setModal] = useState(false);
  const [consultationState, setConsultationState] = useState(1);
  const [ventesList, setVentesList] = useState<any[]>([]);
  const [consultationTableLoading, setConsultationTableLoading] = useState(false);
  const [getDataFromPromise, setGetDataFromPromise] = useState(false);
  const searchRef = useRef<HTMLInputElement>(document.createElement("input"));

  useEffect(() => {
    setSelectOptions(selectOptionsDefaultValues.filter(e => soldValue?.value !== "BIEN" || e.value === constants.CONSULTATION_SELECT_N_DOSSIER || e.value === constants.CONSULTATION_SELECT_ID_BIEN))
    if(soldValue?.value === "BIEN" && selectedValue?.value !== constants.CONSULTATION_SELECT_N_DOSSIER && selectedValue?.value !== constants.CONSULTATION_SELECT_ID_BIEN)
      setSelectedValue(selectOptionsDefaultValues.find(e => e.value === constants.CONSULTATION_SELECT_N_DOSSIER))
  }, [soldValue])
  
  const [prixBien, setPrixBien] = useState(0);
  const [totalEncaissements, setTotalEncaissements] = useState(0);
  const [reliquat, setReliquat] = useState(0);

  const [constantesProjet, setConstantesProjet] = useState<any>(null);

  const [modalVente, setModalVente] = useState(false);
  const [modalRecu, setModalRecu] = useState(false);
  const [modalContrat, setModalContrat] = useState(false);
  const [delaiMoisValue, setDelaiMois] = useState(24);
  const [delaiMoisFlag, setDelaiMoisFlag] = useState(false);
  const delaiMoisRef = useRef<HTMLInputElement>(document.createElement("input"));
  const tailleOptions = [{value: 7, label: "Plus Petite"}, {value: 8, label: "Petite"}, {value: 9, label: "Normale"}, {value: 10, label: "Grande"}, {value: 11, label: "Plus Grande"}, {value: "CUSTOM", label: "Personnalisé"}];
  const [selectedTaille, setSelectedTaille] = React.useState(tailleOptions[2]);
  const [tailleValue, setTaille] = useState(+tailleOptions[2].value);
  const [tailleFlag, setTailleFlag] = useState(false);
  const tailleRef = useRef<HTMLInputElement>(document.createElement("input"));
  
  const [modalDocumentImage, setModalDocumentImage] = useState(false);
  const [documentImage, setDocumentImage] = useState<any>(undefined);
  
  const [modalRR, setModalRR] = useState(false);
  const [modalRRData, setModalRRData] = useState<any>(undefined);
  
  const [modalAss, setModalAss] = useState(false);
  const handleToggleAss = () => setModalAss(!modalAss);
  const [associationPartInfo2, setAssociationPartInfo2] = useState<any>('');
  const [selectedAssociation, setSelectedAssociation] = useState<any>('');

  useEffect(() => {
    let searchParams = new URLSearchParams(location?.search);
    if(!!searchParams.get("cp") && !locationFlag2){
      setSocieteValue(allSocieteValue)
      setSelectedValue(selectOptions.find(e => e.value === constants.CONSULTATION_SELECT_CIN));
      setSearch(searchParams.get("cp") || "");
      setLocationFlag2(true)
    }
    else{
      const projectId = !bienId ? info?.IDPROJET : bienInfo?.IDPROJET
      if(auth?.user?.societes?.length){
        if(projectId){
          for(let e of auth.user.societes)
            if(e.id == projectId){
              setSocieteValue(e);
              break
            }
        }
        else if(!info?.bien){
          for(let e of auth.user.societes)
            if(e.id == auth.user.last_societe){
              setSocieteValue(e);
              break
            }
        }
      }
    }
  }, [info?.IDPROJET, bienInfo?.IDPROJET, auth?.user?.societes, location?.search]);

  // useEffect(() => {
  //   let searchParams = new URLSearchParams(location?.search);
  //   if(!!searchParams.get("cp")){
  //     setSocieteValue(allSocieteValue)
  //     setLocationFlag2(true)
  //   }
  // }, [location?.search])

  useEffect(() => {
    if(!locationFlag && locationFlag2 && societeValue?.id === allSocieteValue.id && selectedValue?.value === constants.CONSULTATION_SELECT_CIN){
      setLocationFlag(true);
      let searchParams = new URLSearchParams(location?.search);
      if(!!searchParams.get("cp")){
        search(searchParams.get("cp") || "");
      }
    }
  }, [locationFlag2, societeValue, selectedValue]);

  const libraryFlags = {
    RECU: {
      color: "darkgreen",
      text: "Reçu de Réservation",
      tooltip: null
    },
    RECU_REMISE_NON_ENCORE: {
      color: "orangered",
      text: "Reçu de Réservation",
      tooltip: "Demande de remise pas encore validée par l'administration"
    },
    RECU_REMISE_REFUSEE: {
      color: "darkred",
      text: "Reçu de Réservation",
      tooltip: "Demande de remise refusée par l'administration"
    },
    ENC_SUPP: {
      color: "darkblue",
      text: "Avances Supplémentaires",
      tooltip: null
    },
    CONTRAT_SIGNE: {
      color: "midnightblue",
      text: "Contrat Signé",
      tooltip: null
    },
    ACTE_DESISTEMENT: {
      color: "midnightblue",
      text: "Acte de Désistement",
      tooltip: null
    },
    ANNULATION_TRANSFERT: {
      color: "midnightblue",
      text: "Annulation de Transfert",
      tooltip: null
    },
    ACCORD_CREDIT: {
      color: "midnightblue",
      text: "Accord de Crédit",
      tooltip: null
    },
    MOTIF_CHEQUE_IMPAYE: {
      color: "midnightblue",
      text: "Motif de Chèque Impayé",
      tooltip: null
    },
    RECU_RESERVATION_SIGNE: {
      color: "midnightblue",
      text: "Reçu de Réservation Signé",
      tooltip: null
    },
    FICHE_VENTE_VALIDEE: {
      color: "midnightblue",
      text: "Fiche de Vente Validée",
      tooltip: null
    },
    OTHER: {
      color: "midnightblue",
      text: "Autre",
      tooltip: null
    },
  };  
  const [recuFiles, setRecuFiles] = useState<any[]>([]);
  const [recusLoading, setRecusLoading] = useState(false);
  const [contratSigneFile, setContratSigneFile] = useState<any>(null);
  const [otherFiles, setOtherFiles] = useState<any[]>([]);
  const [contratSigneFileLoading, setContratSigneFileLoading] = useState(false);
  const [previewBase64, setPreviewBase64] = useState({file: '', fileName: ''});
  const [documentModal, setDocumentModal] = useState(false);
  const [documentFlag, setDocumentFlag] = useState(false);

  const [addDocumentModal, setAddDocumentModal] = useState(false);
  const typeDocOptions = [{value: constants.DOC_CONTRAT_SIGNE, label: "Contrat signé"}, {value: constants.DOC_ACTE_DESISTEMENT, label: "Acte de désistement"}, {value: constants.DOC_ANNULATION_TRANSFERT, label: "Annulation de transfert"}, {value: constants.DOC_ACCORD_CREDIT, label: "Accord de crédit"}, {value: constants.DOC_MOTIF_CHEQUE_IMPAYE, label: "Motif de chèque impayé"}, {value: constants.DOC_RECU_RESERVATION_SIGNE, label: "Reçu de réservation signé"}, {value: constants.DOC_FICHE_VENTE_VALIDEE, label: "Fiche de vente validée"}, {value: constants.DOC_OTHER, label: "Autre"}];
  const [selectedTypeDoc, setSelectedTypeDoc] = useState<any>('');
  const [docCommentValue, setDocCommentValue] = useState('');
  const [addDocPdfs, setAddDocPdfs] = useState<any[]>([]);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: ['application/pdf', 'image/*'],
    multiple: false,
    maxSize: 30000000,
    onDrop: (acceptedFiles, rejectedFiles) => {
      setAddDocPdfs(acceptedFiles);
      if(rejectedFiles?.length && rejectedFiles[0].errors){
        if(rejectedFiles[0].errors.find(e => e.code === "file-invalid-type"))
          alert.error("Veuillez sélectionner des fichiers du type PDF ou Image")
        else if(rejectedFiles[0].errors.find(e => e.code === "file-too-large"))
          alert.error("La taille du fichier est supérieure à 30 Mo")
      }
    }
  });
  const [disableSubmitAddDoc, setDisableSubmitAddDoc] = useState(false);
  const [reEnableAddDoc, setReEnableAddDoc] = useState(false);
  
  const [associationPartInfo, setAssociationPartInfo] = useState<any>('');

  useEffect(() => console.log("addDocPdfs", addDocPdfs), [addDocPdfs]);
  
  const docCommentChangeHandler = (e: ITarget) => setDocCommentValue(e.target.value);

  const handleToggle = () => setModal(!modal);
  const handleToggleAddDocument = () => setAddDocumentModal(!addDocumentModal);

  const addDocumentModalClosedHandle = () => {
    if(reEnableAddDoc){
      setDisableSubmitAddDoc(false);
      setReEnableAddDoc(false);
    }
  };

  const callbackAddDoc = (success) => {
    if(success){
      setReEnableAddDoc(true);
      setAddDocumentModal(false);
      setSelectedTypeDoc('');
      setAddDocPdfs([]);
      retreiveDocuments();
      return
    }
    alert.error("Une erreur s'est produite");
    setDisableSubmitAddDoc(false);
  };

  const addDocHandle0 = async () => {
    if(selectedTypeDoc === ''){
      alert.error("Veuillez sélectionner le type du document");
      return
    }
    if(!addDocPdfs?.length){
      alert.error("Veuillez sélectionner un document");
      return
    }

    setDisableSubmitAddDoc(true);
    var reader = new FileReader();
    reader.onload = function() {
      var arrayBuffer = this.result,
        codedBuffer: string = "";
      (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
          codedBuffer += String.fromCharCode(byte);
      });
      if(info.id){
        if(selectedTypeDoc.value === constants.DOC_CONTRAT_SIGNE)
          addContratSigne(info.id, auth?.user && auth?.user.username ? auth?.user.username : undefined, {codedBuffer}, callbackAddDoc);
      }
    }
    reader.readAsArrayBuffer(addDocPdfs[0]);
  };

  const addDocHandle = async () => {
    if(!selectedTypeDoc){
      alert.error("Veuillez sélectionner le type du document");
      return
    }
    if(!addDocPdfs?.length){
      alert.error("Veuillez sélectionner un document");
      return
    }

    setDisableSubmitAddDoc(true);
    var reader = new FileReader();
    reader.onload = function() {
      var arrayBuffer = this.result,
        codedBuffer: string = "";
      (new Uint8Array(arrayBuffer as ArrayBuffer)).forEach(function (byte: number) {
          codedBuffer += String.fromCharCode(byte);
      });
      if(info.id && addDocPdfs?.length){
        // if(selectedTypeDoc.value === constants.DOC_CONTRAT_SIGNE)
        //   addContratSigne(info.id, auth?.user && auth?.user.username ? auth?.user.username : undefined, {codedBuffer}, callbackAddDoc);
        addDocument(selectedTypeDoc.value, info.id, docCommentValue, auth?.user?.id, auth?.user?.username, {codedBuffer, isPdf: addDocPdfs[0].type === "application/pdf" ? 1 : 0}).then(res => {
          setReEnableAddDoc(true);
          setAddDocumentModal(false);
          setSelectedTypeDoc('');
          setDocCommentValue('');
          setAddDocPdfs([]);
          retreiveDocuments();
        }).catch(e => {
          console.log("error addDoc", e);
          alert.error("Une erreur s'est produite");
          setDisableSubmitAddDoc(false);
        });
      }
    }
    reader.readAsArrayBuffer(addDocPdfs[0]);
  };

  const handleTypeDocChange = data => {
    setSelectedTypeDoc(data || '');
  }

  useEffect(() => {
    getUsers();
  }, [getUsers]);

  const refresh = () => {
    clearVenteCard();
    clearBienCard();
    clearEncaissementLines();
    // if(id !== undefined && id !== null && !isNaN(id) && id >= 0){
    if(id){
      getVenteById(id);
      setConsultationState(1);
    }
    else if(bienId){
      getBienById(bienId);
      setConsultationState(1);
    }
  }

  useEffect(() => {
    refresh()
  }, [id, bienId]);

  useEffect(() => () => {
    clearVenteCard()
    clearBienCard()
    clearEncaissementLines()
  }, []);

  useEffect(() => console.log("vente", info), [info]);//TODO remove this later
  useEffect(() => console.log("bienInfo", bienInfo), [bienInfo]);//TODO remove this later

  useEffect(() => {
    setAssociationPartInfo('')
    setSelectedAssociation('');
    setAssociationPartInfo2('')
    setDocumentFlag(false);
    if(info){
      setDelaiMois((info.IDPROJET === 11 || info.IDPROJET === 16) ? 12 : (info.IDPROJET === 5 && info.TRANCHE?.includes('B')) ? 6 : 24);
      getConstanteProjetInfos(info.IDPROJET || -1, info.PROJET || "").then(e => setConstantesProjet(e));
      if(activeTab === constants.TAB_LIBRARY){
        setDocumentFlag(true);
        retreiveDocuments();
      }
      else{
        setRecuFiles([])
        setOtherFiles([])
      }
    }
    else{
      setConstantesProjet(null);
      setRecuFiles([])
      setOtherFiles([])
    }
  }, [info]);
  
  const handleSocieteChange = data => {
    setSocieteValue(data ? data.value : '');
    searchRef.current.focus();
  }
  const handleSelectChange = data => {
    setSelectedValue(data || '');
    searchRef.current.focus();
  }
  const handleSoldChange = data => {
    setSoldValue(data || '');
    searchRef.current.focus();
  }

  const handleUserChange = data => {
    setUserValue(data ? data.value : '');
  }

  const commercialMyself = () => {
    if(auth?.user?.id)
      setUserValue(users.find(e => e.id === auth.user.id))
  }

  // useEffect(() => {
  //   if(auth?.user?.id !== undefined && userValue === '')
  //     setUserValue(userOptions.find(e => e.value.id === auth.user.id)?.value || '')
  // }, [auth?.user?.id, users]); rj3ha fach tbghi trdha auto (21/12/23)
  
  const handleToggleVente = () => setModalVente(!modalVente);
  const handleToggleRecu = () => setModalRecu(!modalRecu);
  const handleToggleContrat = () => setModalContrat(!modalContrat);

  const handleSelectChangeTaille = data => {
    setSelectedTaille(data || '');
    setTaille(data?.value || tailleOptions[2].value)
  }

  const delaiMoisChangeHandler = (e/*: ITarget*/) => {
    if(!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_CONTRAT_MONTH))
      return
    const re = /^[0-9\b]+$/;
    if(re.test(e.target.value.toString()) && +e.target.value >= 0){
      if(+e.target.value >= 100)
        setDelaiMois(100);
      else
        setDelaiMois(+e.target.value);
    }
    else if(e.target.value == ""){
      setDelaiMois(0);
      e.target.select();
    }
  };

  const tailleChangeHandler = (e/*: ITarget*/) => {
    const re = /^[0-9\b]+$/;
    if(re.test(e.target.value.toString()) && +e.target.value >= 0){
      if(+e.target.value >= 30)
        setTaille(30);
      else
        setTaille(+e.target.value);
      setSelectedTaille(tailleOptions.find(t => t.value === +e.target.value) || tailleOptions[5])
    }
    else if(e.target.value == ""){
      setTaille(0);
      e.target.select();
    }
  };

  useEffect(() => {
    if(!delaiMoisFlag)
      setDelaiMoisFlag(true)
    else if(delaiMoisValue === 0 && delaiMoisRef?.current)
    delaiMoisRef.current.select()
  }, [delaiMoisValue]);

  useEffect(() => {
    if(!tailleFlag)
      setTailleFlag(true)
    else if(tailleValue === 0 && tailleRef?.current)
    tailleRef.current.select()
  }, [tailleValue]);

  const focusHandler = (e) => {
    if(e.target.value == "0")
      e.target.select();
  };

  // useEffect(() => {console.log("cc", societeValue, info?.PROJET, auth?.user?.societes)
  //   if(auth?.user?.societes?.length){
  //     if(info?.PROJET){
  //       for(let e of auth.user.societes)
  //         if(e.LIBELE == info.PROJET){
  //           setSocieteValue(e);
  //           break
  //         }
  //     }
  //     else if(!info?.bien){
  //       for(let e of auth.user.societes)
  //         if(e.id == auth.user.last_societe){
  //           setSocieteValue(e);
  //           break
  //         }
  //     }
  //   }
  // }, [info?.PROJET, auth?.user?.societes]);

  useEffect(() => {
    // if(info.bien && info.bien.PRIX_VENTE !== null && info.bien.PRIX_VENTE !== undefined)
    // if((info.PRIX_M_CLIENT !== undefined && info.PRIX_M_CLIENT > 0) || (info.bien && info.bien.PRIX_VENTE !== null && info.bien.PRIX_VENTE !== undefined))
      setPrixBien(info.PRIX_NET || 0)
      // setPrixBien((info.PRIX_M_CLIENT || info.bien?.PRIX_VENTE || 0) - (info.REMISE || 0))
    // else
    //   setPrixBien(0)
  // }, [info.PRIX_M_CLIENT, info.REMISE, info.bien?.PRIX_VENTE])
  }, [info.PRIX_NET])
  // }, [info.bien?.PRIX_VENTE, info.REMISE])

  // useEffect(() => {
  //   setTotalEncaissements(info.encaissements?.reduce((e, t) => {
  //     return t.contrat_encaissement?.PART ? e + Number(t.contrat_encaissement.PART) : e
  //   }, 0) || 0)
  // }, [info.encaissements])

  useEffect(() => {
    setTotalEncaissements(info.contrat_encaissements?.reduce((e, t) => {
      return t.PART ? e + Number(t.PART) : e
    }, 0) || 0)
  }, [info.contrat_encaissements])

  useEffect(() => {
    setReliquat(Number(prixBien) - Number(totalEncaissements))
  }, [prixBien, totalEncaissements])

  const searchChangeHandler = (e: ITarget) => setSearch(e.target.value);
  const onSearchFocus = (e) => {
    e.target.select();
  };

  const handleSearchKeyDown = (event) => {
    if(event.key === 'Enter')
      search()
  }

  const toggle = tab => {
    if(activeTab !== tab) setActiveTab(tab);
  }

  useEffect(() => {
    if(activeTab === constants.TAB_LIBRARY && !documentFlag){
      setDocumentFlag(true);
      retreiveDocuments();
    }
  }, [activeTab])

  const search = async (searchTerm: any = undefined) => {
    searchTerm = searchTerm || searchValue || "";
    if(!selectedValue || searchTerm === '')
      return
    if(!societeValue){
      alert.info("Veuillez sélectionner un projet");
      return
    }

    setConsultationTableLoading(true);
    let returnedArray: any[] = [];
    const re = /^[0-9\b]+$/;

    if(selectedValue.value === constants.CONSULTATION_SELECT_N_DOSSIER){
      setConsultationState(2);
      if(soldValue?.value === "ALL" || soldValue?.value === "VENTE"){
        const resVentesList = await getVentesByNumDossier(searchTerm, societeValue["id"]/*, auth?.user.societes?.map(e => e.LIBELE) || [], !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
        if(resVentesList?.length)
          returnedArray.push(...resVentesList)
      }
      if(soldValue?.value === "ALL" || soldValue?.value === "BIEN"){
        const resBiensList = await getBiensByN(searchTerm, societeValue["id"]);
        if(resBiensList?.length)
          returnedArray.push(...resBiensList.map(e => ({...e, isBien: true})))
      }
    }
    // else if(selectedValue.value === constants.CONSULTATION_SELECT_ID_CONTRAT){
    //   if(re.test(searchTerm.toString()) && +searchTerm >= 0){
    //     if(id != +searchTerm)
    //       clearVenteCard();
    //     setConsultationState(1);
    //     history.push(`/${consultationOnly ? "consultation" : "nouvel_encaissement"}/${searchTerm}`)
    //   }
    // }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_ID_CONTRAT){
      if(re.test(searchTerm.toString()) && +searchTerm >= 0){
        setConsultationState(1);
        clearVenteCard();
        const resVenteID = await getVenteIDFromID(+searchTerm, societeValue["id"]);
        if(resVenteID){
          setConsultationState(1);
          if(id == resVenteID)
            getVenteById(id)
          else
            history.push(`/${consultationOnly ? "consultation" : isReplacement ? "remplacement_encaissement" : "nouvel_encaissement"}/${resVenteID.toString()}`)
        }
        else
          alert.info("Aucun résultat trouvé")
      }
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_ID_BIEN){
      if(re.test(searchTerm.toString()) && +searchTerm >= 0){
        setConsultationState(1);
        clearVenteCard();
        let resVenteID: any = undefined;
        if(soldValue?.value === "ALL" || soldValue?.value === "VENTE")
          resVenteID = await getVenteIDFromBienID(+searchTerm, societeValue["id"]);
        if(resVenteID){
          setConsultationState(1);
          if(id == resVenteID)
            getVenteById(id)
          else
            history.push(`/${consultationOnly ? "consultation" : isReplacement ? "remplacement_encaissement" : "nouvel_encaissement"}/${resVenteID.toString()}`)
        }
        else if(soldValue?.value === "ALL" || soldValue?.value === "BIEN"){
          const bienId = +searchTerm
          setConsultationState(1);
          if(id == bienId)
            getVenteById(id)
          else
            history.push(`/consultation/bien/${bienId.toString()}`)
        }
        else
          alert.info("Aucun résultat trouvé")
      }
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_CIN){
      setConsultationState(2);
      const resVentesList = await getVentesByCIN(searchTerm, societeValue["id"]/*, auth?.user.societes?.map(e => e.LIBELE) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(resVentesList?.length)
        returnedArray = resVentesList
    }
    else if(selectedValue.value === constants.CONSULTATION_SELECT_REF_REG){
      setConsultationState(2);
      const resVentesList = await getVentesByEnc(searchTerm, societeValue["id"]/*, auth?.user.societes?.map(e => e.LIBELE) || []/*, !!auth.user.privileges?.includes(PRIVILEGE.FULL_MENU)*/);
      if(resVentesList?.length)
        returnedArray = resVentesList
    }

    setGetDataFromPromise([constants.CONSULTATION_SELECT_CIN, constants.CONSULTATION_SELECT_REF_REG].includes(selectedValue.value));

    setConsultationTableLoading(false);
    setVentesList(returnedArray);
  }

  const selectVente = e => {
    clearVenteCard();
    setConsultationState(1);
    if(id == e)
      getVenteById(id)
    else
      history.push(`/${consultationOnly ? "consultation" : isReplacement ? "remplacement_encaissement" : "nouvel_encaissement"}/${e}`)
  }

  const selectBien = e => {
    clearBienCard();
    setConsultationState(1);
    if(bienId == e)
      getBienById(bienId)
    else
      history.push(`/consultation/bien/${e}`)
  }

  const modalClosedHandle = () => {
    setVentesList([]);
  };

  const retreiveDocuments = async () => {
    if(recuFiles?.some(e => e.loading) || otherFiles?.some(e => e.loading) || !info?.id)
      return

    setRecuFiles([])
    setOtherFiles([])
    
    setRecusLoading(true)
    const recu_images = await getRecuImages(info.id)
    setRecusLoading(false)
    if(recu_images?.length){
      setRecuFiles([...recu_images].map(e => ({recu_image: e, loading: true})))
      for(let ri of recu_images){
        const fileName = `recu__${ri.id}__${ri.contrat_id}.pdf`;
        getDocument(`recus/${fileName}`).then(file => {
          setRecuFiles(e => e.map(e => e.recu_image.id === ri.id ? {...e, loading: false, file, fileName, hide: recu_images.find(e => e.from_dr === 1) && ri.remise_state === -1} : e))
        });
      }
    }

    const available_files = await getAvailableDocuments(info.id);
    if(available_files?.length){
      setOtherFiles([...available_files].map(e => {
        return {info: {id: e.id, username: e.userName, date: e.createdAt, type: e.type}, loading: true}
      }))
      for(let af of available_files){
        const type = af.type;
        const fileName = af.documentName;
        let folderName = "autres";
        switch(type){
          case constants.DOC_CONTRAT_SIGNE: folderName = "contrats_signes"; break;
          case constants.DOC_ACTE_DESISTEMENT: folderName = "actes_desistement"; break;
          case constants.DOC_ANNULATION_TRANSFERT: folderName = "annulations_transfert"; break;
          case constants.DOC_ACCORD_CREDIT: folderName = "accords_credit"; break;
          case constants.DOC_MOTIF_CHEQUE_IMPAYE: folderName = "motifs_cheques_impayes"; break;
          case constants.DOC_RECU_RESERVATION_SIGNE: folderName = "recus_reservation_signes"; break;
          case constants.DOC_FICHE_VENTE_VALIDEE: folderName = "fiches_vente_validees"; break;
          case constants.DOC_OTHER: folderName = "autres"; break;
        }
        getDocument(`documents/${folderName}/${fileName}`).then(file => {
          setOtherFiles(e => e.map(e => e.info.id === af.id ? {...e, loading: false, file, fileName, isPdf: af.documentType === "pdf"} : e))
        });
      }
    }
  }

  const createRecu = (isAssociation = false, associationId = undefined) => {
    setModalRRData({isNewRecu: true, isAssociation, associationId, vente: info});
    setModalRR(true)
  }

  return false ? <LoadingPage/> : (
    <>
      <Container>
        <Row className="justify-content-between" style={{marginBottom: "20px"}}>
{/* <div style={{height: "15px", width: "15px", position: "absolute", zIndex: 1}} onClick={() => setModalRecu(true)}></div> */}
          {/* <Col sm="12" md="7"><h2 className="title"><FontAwesomeIcon icon={faBookmark} />&nbsp;&nbsp;Consultation</h2></Col> */}
          <Col xs="12" md="4" style={{display: "flex", alignItems: "center"}}>{consultationOnly ? <h2 className="title" style={{marginBottom: 0}}>Consultation</h2> : <h5 className="title" style={{marginBottom: 0}}>{isReplacement ? "Remplacement chèques" : "Nouvel Encaissement"}</h5>}</Col>
          <Col xs="12" md="2" className="mb-2 mb-md-0 pl-2 pr-2">
              <Select
                id="societes"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Sélectionner un projet...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectSocieteOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col>
          <Col xs="12" md="2" className="mb-2 mb-md-0 pl-2 pr-2">
              <Select
                name="sold"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={{value: "VENTE", label: "Vendus"}}
                value={soldValue}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleSoldChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={false}
                options={soldOptions}                
              />
          </Col>
          <Col xs="12" md="2" className="mb-2 mb-md-0 pl-2 pr-2">
              <Select
                name="searchSelect"
                className="reactselect"
                classNamePrefix="react-select"
                defaultValue={selectOptions[0]}
                value={selectedValue}
                // value={{value: societeValue.value, label: societeValue.label}}
                onChange={handleSelectChange}
                isClearable={false}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={false}
                options={selectOptions}                
              />
          </Col>
          {/* <Col xs="9" md="1">
            <Input placeholder="N°..." innerRef={searchRef} value={searchValue} onChange={searchChangeHandler} onKeyDown={handleSearchKeyDown} onFocus={onSearchFocus} />
          </Col>
          <Col xs="3" md="1">
            <Button className="btnA"
              onClick={search}>
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col> */}
          <Col xs="12" md="2" className="pl-2" style={{display: "flex"}}>
            <Input style={{display: "inline-flex", flex: 1, marginRight: "10px"}} placeholder="N°..." innerRef={searchRef} value={searchValue} onChange={searchChangeHandler} onKeyDown={handleSearchKeyDown} onFocus={onSearchFocus} />
            <Button className="btnA"
              onClick={() => search()}>
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </Col>
        </Row>
      </Container>
      <Container style={{display: "none"}}>
        <Row className="justify-content-between">
          <Col sm="12" md="5"><h2 className="title">Consultation</h2></Col>
          {/* <Col sm="12" md="3" className="listPageFilterTitle">
            <Label for="verse">Projet : </Label>
          </Col>
          <Col sm="12" md="4" className="listPageFilterSelect">
              <Select
                id="societes"
                className="reactselect"
                classNamePrefix="react-select"
                value={societeValue ? {label: societeValue["LIBELE"], value: societeValue} : null}
                onChange={handleSocieteChange}
                placeholder={'Chercher par nom...'}
                isClearable={false}
                // isLoading={loadingS}
                loadingMessage={() => 'Chargement...'}
                noOptionsMessage={() => 'pas de resultat'}
                isSearchable={true}
                labelKey='LIBELE'
                options={selectSocieteOptions}
                menuContainerStyle={{ zIndex: 9999999 }}
              />
          </Col> */}
        </Row>
      </Container>
      <Container className="venteInputsContainer" style={{display: "none"}}>
        <Row>
          <Col xs="12" sm="6" md="2">
            <FormGroup>
              <Label for="search">Rechercher</Label>
              <Input id="search" placeholder="Rechercher..." value={searchValue} onChange={searchChangeHandler} />
            </FormGroup>
          </Col>
          {/* <Button onClick={() => {
            history.push('/${consultationOnly ? "consultation" : "nouvel_encaissement"}/10901')
          }}>go to 10901</Button> */}
        </Row>
      </Container>
      {consultationState === 2 ? consultationTableLoading ? <Loading /> : <VenteListTable ventesData={ventesList} selectVente={selectVente} selectBien={selectBien} getDataFromPromise={getDataFromPromise} showProjectColumn={societeValue?.id === "ALL"} editCallback={() => search()} /> : <div className="fadeAnimation"><Container className="venteContainer">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === constants.TAB_BIEN ? " active" : ""}`}
              onClick={() => { toggle(constants.TAB_BIEN); }} >
              <FontAwesomeIcon icon={faBuilding} className="consultationTabIcons" />{!bienId ? "Bien Vendu" : "Bien"}
            </NavLink>
          </NavItem>
          {(info?.TYPE_VENTE === "ASSOCIATION" && !bienId) && <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === constants.TAB_ASSOCIATION ? " active" : ""}`}
              onClick={() => { toggle(constants.TAB_ASSOCIATION); }} >
              <FontAwesomeIcon icon={faUsers} className="consultationTabIcons" />Association
            </NavLink>
          </NavItem>}
          {!bienId && <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === constants.TAB_CLIENT ? " active" : ""}`}
              onClick={() => { toggle(constants.TAB_CLIENT); }} >
              <FontAwesomeIcon icon={faUserCircle} className="consultationTabIcons" />Clients ({info?.contrat_clients?.map(e => e.client).map(e => e?.id).filter((value, index, self) => value === undefined || self.indexOf(value) === index).length || 0})
              {/* Clients ({[...new Set(info?.contrat_clients?.map(e => e.ID_CLIENT) || [])].length || 0}) */}
            </NavLink>
          </NavItem>}
          {!bienId && <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === constants.TAB_ENCAISSEMENT ? " active" : ""}`}
              onClick={() => { toggle(constants.TAB_ENCAISSEMENT); }}
              // disabled={!info?.hasPermission} 
              >
              <FontAwesomeIcon icon={faMoneyCheckAlt} className="consultationTabIcons" />Encaissements ({info?.contrat_encaissements?.length || 0})
            </NavLink>
          </NavItem>}
          {(!!consultationOnly && !bienId) && <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === constants.TAB_LIBRARY ? " active" : ""}`}
              onClick={() => { toggle(constants.TAB_LIBRARY); }}
              disabled={!info?.hasPermission} >
              <FontAwesomeIcon icon={faFileAlt} className="consultationTabIcons" />Bibliothèque
            </NavLink>
          </NavItem>}
          {(!!consultationOnly && !!bienId) && <NavItem>
            <NavLink
              className={`fullFlexCenter${activeTab === "k" ? " active" : ""}`}
              onClick={() => { /*toggle(constants.TAB_LIBRARY);*/ }} >
              <FontAwesomeIcon icon={faFileAlt} className="consultationTabIcons" />Bibliothèque
            </NavLink>
          </NavItem>}
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={constants.TAB_BIEN}>
            {loading || loadingB ? <Loading topSpace /> : <VenteInfo isBien={!!bienId} info={info} bienInfo={bienInfo} refreshVente={refresh} />}
          </TabPane>
          <TabPane tabId={constants.TAB_ASSOCIATION}>
            {info.TYPE_VENTE === "ASSOCIATION" ? loading ? <Loading topSpace /> : (id !== undefined && id !== null && !isNaN(id) && id >= 0 && info?.bien) ?
              <Association associations={info.associations} vente={info} division={info.bien.division} etages={info.bien.ETAGE_ASS} associationPartInfo={associationPartInfo} setAssociationPartInfo={setAssociationPartInfo} createRecu={createRecu} setSelectedAssociationHandle={(e) => {setSelectedAssociation(e); setActiveTab(constants.TAB_LIBRARY)}} /> : <Container>
              <Row>
                <p className="noTableData">Aucune vente sélectionnée</p>
              </Row>
            </Container> : null}
          </TabPane>
          <TabPane tabId={constants.TAB_CLIENT}>
            <ClientTable linesData={info.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []} />
            {/* <ClientTable linesData={info.contrat_clients?.filter((value, index, self) => self.findIndex(e => e.ID_CLIENT === value.ID_CLIENT) === index) || []} /> */}
            {/* <ClientTable linesData={info.clients || []} /> */}
            {/* <VClientContainer tableLines={clientTableLines} setTableLines={setClientTableLines} userValue={userValue} projet={societeValue["LIBELE"]} /> */}
          </TabPane>
          <TabPane tabId={constants.TAB_ENCAISSEMENT}>
            {!!(!consultationOnly && !isReplacement && info?.bien) && <Container>
              <Row>
                <h3>Anciens Encaissements</h3>
              </Row>
            </Container>}
            <EncaissementTable linesData={info.contrat_encaissements || []} venteID={info.id || 0} associations={info.associations} consultationOnly={consultationOnly} isReplacement={isReplacement} setAssociationPartInfo={setAssociationPartInfo} switchToAssociation={() => (setActiveTab(constants.TAB_ASSOCIATION), window.scrollTo(0, 0))} />
            {consultationOnly && <Container className="mt-2">
              <Row>
                <Col xs="6" className="text-right">
                  <strong>Prix Net : </strong>
                </Col>
                <Col xs="6">
                  {prixBien.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ` Dh${info.REMISE ? ` (dont une remise de ${info.REMISE.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Dh du total)` : ""}`}
                </Col>
              </Row>
              <Row>
                <Col xs="6" className="text-right">
                  <strong>Total des encaissements : </strong>
                </Col>
                <Col xs="6">
                  <strong>{totalEncaissements.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}</strong> {prixBien ? <span className="encPercent" style={{color: "hsl(" + (Math.ceil((totalEncaissements * 100) / prixBien) * 1.2).toString(10) + ", 100%, 50%)"}}>({Math.ceil((totalEncaissements * 100) / prixBien)}%)</span> : null}
                </Col>
              </Row>
              <Row>
                <Col xs="6" className="text-right">
                  <strong>Montant restant à payer : </strong>
                </Col>
                <Col xs="6" style={reliquat < 0 ? {color: "red"} : {}}>
                  {reliquat.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " Dh"}
                </Col>
              </Row>
            </Container>}
            {!!(!consultationOnly && !isReplacement && info?.bien) && <Container className="mt-2 mb-1">
              <Row>
                <Col xs="12" lg="6">
                  <h4>Nouveaux Encaissements</h4>
                </Col>
                <Col sm="12" md="3" lg="2" className="listPageFilterTitle">
                  <Label for="user" style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>Commercial : {!!(!userValue || userValue?.id !== auth?.user?.id) && <div style={{cursor: "pointer", textDecoration: "underline"}} onClick={commercialMyself}>Moi-même</div>}</Label>
                </Col>
                <Col xs="12" md="9" lg="4" className="listPageFilterSelect">
                  <Select
                    name="user"
                    className="reactselect"
                    classNamePrefix="react-select"
                    value={userValue ? {label: userValue["username"], value: userValue} : null}
                    onChange={handleUserChange}
                    placeholder={'Chercher par nom...'}
                    isClearable={false}
                    isLoading={loadingU}
                    loadingMessage={() => 'Chargement...'}
                    noOptionsMessage={() => 'pas de resultat'}
                    isSearchable={true}
                    labelKey='username'
                    // valueKey='countryCode'
                    options={userOptions}
                    menuContainerStyle={{ zIndex: 9999999 }}
                  />
                </Col>
              </Row>
            </Container>}
            {!!(!consultationOnly && !isReplacement && info?.bien) && <VEncaissementContainer project={{id: info.IDPROJET, LIBELE: info.PROJET || ""}} /*clients={clientTableLines}*/ bien={info.bien} encaissementlines={encaissementlines} isConsultation={true} consultationContratID={info.id} consulationClients={info.contrat_clients?.map(e => e.client).filter((value, index, self) => value?.id === undefined || self.findIndex(e => e?.id === value?.id) === index) || []} consultationEncaissements={info.contrat_encaissements || []} consultationIsAssociation={info.TYPE_VENTE === "ASSOCIATION"} consultationAssociations={info.associations} consultationContrat={info} userValue={userValue} />}
            {/* <VEncaissementContainer project={societeValue} clients={clientTableLines} bien={info} encaissementlines={encaissementlines} switchToBien={() => (setActiveTab(constants.TAB_BIEN), window.scrollTo(0, 0))} /> */}
          </TabPane>
          {consultationOnly && <TabPane tabId={constants.TAB_LIBRARY}>
            {loading ? <Loading topSpace /> : (id !== undefined && id !== null && !isNaN(id) && id >= 0 && info?.bien) ? <Container className="CardInfo fadeAnimation">
              <Row className="justify-content-end" style={{padding: 0}}>
                {!!(auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER)/* || auth?.user?.privileges?.includes(PRIVILEGE.VENTE_NORMALE)*/) && <span className="initializeBtn mr-3" title="Générer un nouveau reçu de vente" onClick={() => {
                  if(info?.TYPE_VENTE === "ASSOCIATION"){
                    alert.info("Veuillez sélectionner une part")
                    setActiveTab(constants.TAB_ASSOCIATION)
                    window.scrollTo(0, 0)
                  }
                  else
                    createRecu()
                }}><FontAwesomeIcon icon={faPencilRuler} />&nbsp;Générer un reçu</span>}
                <span className="initializeBtn" title="Actualiser la liste des documents" onClick={() => retreiveDocuments()}><FontAwesomeIcon icon={faSync} />&nbsp;Actualiser</span>
              </Row>
              {recuFiles?.length ? <Row>
                <Col xs="12" sm="8" style={{border: "none"}}>
                  <h3>Reçus des paiements</h3>
                </Col>
                {info?.TYPE_VENTE === "ASSOCIATION" && <Col xs="12" sm="4" className="filterByPartConsultation">
                  <b style={{whiteSpace: "nowrap"}}>Filtrer par part :&nbsp;</b>
                  <div className={`encaissementChooseAsso${selectedAssociation ? " encaissementChooseAssoSelected" : ""}`} title={selectedAssociation ? `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}` : ""} onClick={() => setModalAss(true)}>
                    {!selectedAssociation ? "Choisir une part de l'association" : `${selectedAssociation.POURCENTAGE || "-"}% | ${selectedAssociation.ETAGE === "0" ? "RDC" : `Étage ${selectedAssociation.ETAGE || "-"}`} | ${selectedAssociation.contrat_clients?.map(e => e.client).map(e => `${e.NOM} ${e.PRENOM}`).join(", ")}`}
                    {!!selectedAssociation && <FontAwesomeIcon icon={faTimes} className="encaissementChooseAssoDismiss" onClick={e => {e.stopPropagation(); setSelectedAssociation('')}} />}
                  </div>
                </Col>}
              </Row> : null}
              {/* {recuFilesLoading ? <Loading topSpace={false} /> : recuFiles.map((e, key) => <Row className={`libraryRow${e.hide ? " libraryRowHidden" : ""}`} key={key}> */}
              {recusLoading ? <Loading topSpace={false} /> : recuFiles.filter(e => !selectedAssociation || selectedAssociation.id == e.recu_image.association_id).map((e, key) => <Row className={`libraryRow${e.hide ? " libraryRowHidden" : ""}`} key={key}>
                <Col xs="12" md="4" className="libraryNameCol">
                  <span className="libraryName" title={e.fileName || ""}>
                    <FontAwesomeIcon icon={faFilePdf} />&nbsp;{e.loading ? <>Chargement...&nbsp;<FontAwesomeIcon icon={faSpinner} className="spinner" /></> : e.fileName}
                    <FontAwesomeIcon icon={faQuestionCircle} className="libraryInfoTooltip" data-tip data-for={`document_recu_${e.recu_image.id}_tooltip`} />
                    <ReactTooltip effect="solid" id={`document_recu_${e.recu_image.id}_tooltip`} type={"dark"}>
                      créé le {e.recu_image.createdAt ? moment(e.recu_image.createdAt).format('DD/MM/YYYY à HH:mm') : "-"} par {e.recu_image.username}
                    </ReactTooltip>
                  </span>
                </Col>
                <Col xs="12" md="4" className="libraryFlagCol">
                  <span className="libraryFlag" style={{backgroundColor: libraryFlags[e.recu_image.enc_supp === 1 ? "ENC_SUPP" : e.recu_image.remise_state === -1 ? "RECU_REMISE_NON_ENCORE" : e.recu_image.remise_state === 0 ? "RECU_REMISE_REFUSEE" : "RECU"].color}}>
                    {libraryFlags[e.recu_image.enc_supp === 1 ? "ENC_SUPP" : e.recu_image.remise_state === -1 ? "RECU_REMISE_NON_ENCORE" : e.recu_image.remise_state === 0 ? "RECU_REMISE_REFUSEE" : "RECU"].text}&nbsp;
                    {libraryFlags[e.recu_image.enc_supp === 1 ? "ENC_SUPP" : e.recu_image.remise_state === -1 ? "RECU_REMISE_NON_ENCORE" : e.recu_image.remise_state === 0 ? "RECU_REMISE_REFUSEE" : "RECU"].tooltip ? <span>
                      <FontAwesomeIcon icon={faQuestionCircle} style={{cursor: "pointer"}} data-tip data-for="remise_validee_tooltip" />
                      <ReactTooltip effect="solid" id="remise_validee_tooltip" type={"dark"}>
                        {e.recu_image.remise_state === -1 ? "Demande de remise pas encore validée par l'administration" : e.recu_image.remise_state === 0 ? "Demande de remise refusée par l'administration" : ""}
                      </ReactTooltip>
                    </span> : null}
                  </span>
                </Col>
                <Col xs="12" md="4" className="libraryBtnsCol">
                  <button className="libraryBtn libraryBtnPreview" disabled={e.loading} onClick={() => {
                    setPreviewBase64({file: e.file || '', fileName: e.fileName || ''});
                    setDocumentModal(true);
                  }}>
                    <FontAwesomeIcon icon={faBookOpen} />&nbsp;Aperçu
                  </button>
                  <button className="libraryBtn libraryBtnPrint" disabled={e.loading} onClick={() => {
                    printBase64(e.file || '')
                  }}>
                    <FontAwesomeIcon icon={faPrint} />&nbsp;Imprimer
                  </button>
                  <button className="libraryBtn libraryBtnDownload" disabled={e.loading} onClick={() => {
                    downloadBase64(e.file || '', e.fileName)
                  }}>
                    <FontAwesomeIcon icon={faFileDownload} />&nbsp;Télécharger
                  </button>
                  {!!auth?.user?.privileges?.includes(PRIVILEGE.WEBMASTER) && <button className="libraryBtn libraryBtnRecreate" disabled={e.loading} onClick={() => {
                    setModalRRData({recu: e.recu_image, vente: info}); setModalRR(true)
                  }}>
                    <FontAwesomeIcon icon={faPencilRuler} />&nbsp;Recréer
                  </button>}
                </Col>
              </Row>)}
              {/* <h6 style={{color: "red"}}>Besoin d'un recu? envoyez un message whatsapp à Ayoub avec ces informations: {info?.N} {info?.PROJET}{info?.TYPE_VENTE === "ASSOCIATION" ? ", la part" : ""}, type de recu (reservation ou supplémentaire)</h6> */}
              {otherFiles?.length ? <Row>
                <h3>Autres documents</h3>
              </Row> : null}
              {otherFiles?.length ? otherFiles.map((e, key) => <Row className="libraryRow" key={key}>
                <Col xs="12" md="4" className="libraryNameCol">
                  <span className="libraryName" title={e.fileName || ""}>
                    <FontAwesomeIcon icon={e.isPdf ? faFilePdf : faFileImage} />&nbsp;{e.loading ? <>Chargement...&nbsp;<FontAwesomeIcon icon={faSpinner} className="spinner" /></> : e.fileName}&nbsp;
                    <FontAwesomeIcon icon={faQuestionCircle} className="libraryInfoTooltip" data-tip data-for={`document_contrat_signe_tooltip_${key}`} />
                    <ReactTooltip effect="solid" id={`document_contrat_signe_tooltip_${key}`} type={"dark"}>
                      créé le {e.info.date ? moment(e.info.date).format('DD/MM/YYYY à HH:mm') : "-"} par {e.info.username}
                    </ReactTooltip>
                  </span>
                </Col>
                <Col xs="12" md="4" className="libraryFlagCol">
                  <span className="libraryFlag" style={{backgroundColor: libraryFlags[e.info.type]?.color || "red"}}>
                    {libraryFlags[e.info.type]?.text || "inconnu"}
                  </span>
                </Col>
                <Col xs="12" md="4" className="libraryBtnsCol">
                  <button className="libraryBtn libraryBtnPreview" disabled={e.loading} onClick={() => {
                    if(!e.isPdf){
                      setDocumentImage({file: e.file ? `data:image/jpeg;base64,${e.file}` : undefined, fileName: e.fileName || '', type: libraryFlags[e.info.type]?.text || ''})
                      setModalDocumentImage(true)
                    }
                    else{
                      setPreviewBase64({file: e.file || '', fileName: e.fileName || ''});
                      setDocumentModal(true);
                    }
                  }}>
                    <FontAwesomeIcon icon={faBookOpen} />&nbsp;Aperçu
                  </button>
                  <button className="libraryBtn libraryBtnPrint" disabled={e.loading} onClick={() => {
                    if(e.file){
                      if(!e.isPdf)
                        printBase64Image(e.file)
                      else
                        printBase64(e.file)
                    }
                  }}>
                    <FontAwesomeIcon icon={faPrint} />&nbsp;Imprimer
                  </button>
                  <button className="libraryBtn libraryBtnDownload" disabled={e.loading} onClick={() => {
                    if(e.file){// disabled={!e.isPdf} style={!e.isPdf ? {pointerEvents: "none"} : {}}
                      if(!e.isPdf)
                        downloadImg(`data:image/jpeg;base64,${e.file}`, `${(e.fileName || "document")}_pris_le`)
                      else
                        downloadBase64(e.file || '', e.fileName)
                    }
                  }}>
                    <FontAwesomeIcon icon={faFileDownload} />&nbsp;Télécharger
                  </button>
                </Col>
              </Row>) : null}
            </Container> : null}
            {(id !== undefined && id !== null && !isNaN(id) && id >= 0 && info?.bien) ? <Container>
              <Row className="btnAtRight">
                <Button
                  className="btn btn-info linesConfirmationBtn linesDeleteBtn"
                  onClick={() => setAddDocumentModal(true)}
                  ><FontAwesomeIcon icon={faCloudUploadAlt} />&nbsp;&nbsp;Ajouter un document</Button>
              </Row>
            </Container> : null}
          </TabPane>}
        </TabContent>
      </Container>

      {!!(consultationOnly && id !== undefined && id !== null && !isNaN(id) && id >= 0 && info?.bien && info?.hasPermission) && <Container className="mb-3">
        <Row className="justify-content-center">
          <PDFLink documentType={"vente"}
            data={info}
            download={false}
            buttonText="Fiche de Vente"
            customClassNames="btn btn-success linesConfirmationBtn linesDeleteBtn pl-3 pr-3 mb-2"
            customButtonIcon={faFileInvoice}
            iconSize="inherit"
            allowPrintPreview={true}
            style={{marginRight: "20px", marginLeft: "20px", fontWeight: 600}} />
          {(info.REMISE_VALIDEE !== 0 && info.REMISE_VALIDEE !== -1) || !info.REMISE ? <Button
            // color="info"
            className="btnB linesConfirmationBtn linesDeleteBtn pl-3 pr-3 mb-2"
            style={{marginRight: "20px", marginLeft: "20px", fontWeight: 600}}
            onClick={() => setModalContrat(true)}
            ><FontAwesomeIcon icon={faFileContract} />&nbsp;&nbsp;Contrat de Vente</Button> : null}
        </Row>
      </Container>}
      </div>}

      {/* <Modal isOpen={modal} toggle={handleToggle} onClosed={modalClosedHandle}>
        <ModalHeader toggle={handleToggle}><FontAwesomeIcon icon={faMoneyBill} />&nbsp;&nbsp;BUG, please report!</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  Voulez-vous... ? nn ({(console.log("ventesList", ventesList), ventesList.length)})
                </Col>
              </Row>
              <Row>
                <VenteListTable ventesData={ventesList} selectVente={selectVente} />
              </Row>
            </Container>
        </ModalBody>
      </Modal> */}

      <Modal isOpen={modalVente} toggle={handleToggleVente}>
        <ModalHeader toggle={handleToggleVente}><FontAwesomeIcon icon={faFileInvoice} />&nbsp;&nbsp;Fiche de Vente</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row className="justify-content-center">
                <PDFLink documentType={"vente"}
                  data={info}
                  download={false}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"vente"}
                  data={info}
                  download={false}
                  print={true}
                  spinner={true}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"vente"}
                  data={info}
                  spinner={true} />
              </Row>
            </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalRecu} toggle={handleToggleRecu}>
        <ModalHeader toggle={handleToggleRecu}><FontAwesomeIcon icon={faReceipt} />&nbsp;&nbsp;Reçu</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row className="justify-content-center">
                <PDFLink documentType={"recu"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  download={false}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"recu"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  download={false}
                  print={true}
                  spinner={true}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"recu"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  spinner={true} />
              </Row>
            </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalContrat} toggle={handleToggleContrat}>
        <ModalHeader toggle={handleToggleContrat}><FontAwesomeIcon icon={faFileContract} />&nbsp;&nbsp;Contrat de Vente</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="delaiMois">Le délai prévisionnel d’achèvement des travaux</Label>
                    <InputGroup className="quantityInputGroup">
                      <Input type="number" id="delaiMois" placeholder="Le délai prévisionnel d’achèvement des travaux (en mois)..." pattern="[0-9]*" disabled={!auth?.user?.privileges?.includes(PRIVILEGE.EDIT_CONTRAT_MONTH)} className="form-control" innerRef={delaiMoisRef} value={delaiMoisValue} onChange={delaiMoisChangeHandler} onFocus={focusHandler} />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>Mois</InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center mb-3">
                <Col xs="12">
                  <FormGroup>
                    <Label for="taille">Taille du Texte : </Label>
                    <Row>
                    <Col xs="6">
                    <Select
                      name="tailleSelect"
                      className="reactselect"
                      classNamePrefix="react-select"
                      defaultValue={tailleOptions[0]}
                      value={selectedTaille}
                      // value={{value: societeValue.value, label: societeValue.label}}
                      onChange={handleSelectChangeTaille}
                      isClearable={false}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={tailleOptions}
                    />
                    </Col>
                    <Col xs="6">
                    <Input type="number" id="taille" placeholder="Taille du Texte..." pattern="[0-9]*" className="form-control" innerRef={tailleRef} value={tailleValue} onChange={tailleChangeHandler} onFocus={focusHandler} />
                    </Col>
                    </Row>
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <PDFLink documentType={"contrat"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  download={false}
                  fontSizeFactor={tailleValue}
                  delaiMois={delaiMoisValue}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"contrat"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  download={false}
                  print={true}
                  spinner={true}
                  fontSizeFactor={tailleValue}
                  delaiMois={delaiMoisValue}
                  style={{marginRight: "10px"}} />
                <PDFLink documentType={"contrat"}
                  data={{...info, constantesProjet, authUserId: auth?.user && auth?.user.id ? auth?.user.id : undefined}}
                  spinner={true}
                  fontSizeFactor={tailleValue}
                  delaiMois={delaiMoisValue} />
              </Row>
            </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={addDocumentModal} toggle={handleToggleAddDocument} onClosed={addDocumentModalClosedHandle}>
        <ModalHeader toggle={handleToggleAddDocument}><FontAwesomeIcon icon={faCloudUploadAlt} />&nbsp;&nbsp;Ajouter un document</ModalHeader>
        <ModalBody>
            <Container className="linesConfirmationContainer">
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="type_doc">Type du document</Label>
                    <Select
                      id="type_doc"
                      name="type_doc"
                      className="reactselect"
                      classNamePrefix="react-select"
                      // defaultValue={civiliteOptions[0]}
                      value={selectedTypeDoc}
                      // value={{value: societeValue.value, label: societeValue.label}}
                      onChange={handleTypeDocChange}
                      isClearable={true}
                      loadingMessage={() => 'Chargement...'}
                      noOptionsMessage={() => 'pas de resultat'}
                      isSearchable={false}
                      options={typeDocOptions}                
                    />
                    {/* <Input id="civilite" placeholder="Civilité..." value={civiliteValue} onChange={civiliteChangeHandler} /> */}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup style={{position: "relative"}}>
                    <section>
                      <div {...getRootProps({className: `dropzone${isDragActive ? " dropzoneHovered" : ""}`})}>
                        <input {...getInputProps()} />
                        {addDocPdfs?.length ? <aside className="thumbContainer">
                          <div className="thumbDelete" onClick={e => (e.stopPropagation(), setAddDocPdfs([]))} title="Supprimer le document"><FontAwesomeIcon icon={faTimes} style={{fontSize: "small"}} /></div>
                          <div className="thumb" style={{height: "auto"}} key={addDocPdfs[0].name}>
                            <div className="thumbInner">
                              <span className="thumbFileName"><FontAwesomeIcon icon={faFilePdf} />&nbsp;{addDocPdfs[0].name}</span>
                            </div>
                          </div>
                        </aside> : <span style={{margin: "20px"}}><FontAwesomeIcon icon={faFilePdf} /> Choisir ou <FontAwesomeIcon icon={faHandRock} /> déposer le <span style={{fontWeight: 600}}>{selectedTypeDoc.label ? `"${selectedTypeDoc.label.toLowerCase()}"` : "document"}</span> ici</span>}
                      </div>
                    </section>
                    <div className="bottomFloatingInputText text-right"><a href="https://pdfjoiner.com/fr" target="_blank">Convertir des images en PDF</a></div>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label for="doc_comment">Commentaire</Label>
                    <Input id="doc_comment" placeholder="Commentaire..." value={docCommentValue} onChange={docCommentChangeHandler} />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="justify-content-center stickyBottom">
                <Button
                  className="btn btn-success linesConfirmationBtn"
                  onClick={addDocHandle}
                  disabled={disableSubmitAddDoc}
                  ><FontAwesomeIcon icon={disableSubmitAddDoc ? faSpinner : faCheckCircle} className={disableSubmitAddDoc ? "spinner" : ""} />&nbsp;&nbsp;Ajouter</Button>
              </Row>
            </Container>
        </ModalBody>
      </Modal>

      <Modal isOpen={modalAss} toggle={handleToggleAss} className="modal-dialog-large" style={{minWidth: "900px"}} modalClassName="xOverflowModal">
        <ModalHeader toggle={handleToggleAss}><FontAwesomeIcon icon={faCheck} />&nbsp;&nbsp;Choix de l'association</ModalHeader>
        <ModalBody>
          <Association associations={info?.associations} etages={info?.bien?.ETAGE_ASS} associationPartInfo={associationPartInfo2} setAssociationPartInfo={setAssociationPartInfo2} chooseForEnc={(e) => {
            setSelectedAssociation(e);
            setModalAss(false);
          }} isModal isChoosingPart />
        </ModalBody>
      </Modal>

      <RecuRecreation modal={modalRR} setModal={setModalRR} modalData={modalRRData} savedCallback={e => {
        setPreviewBase64({file: e.file, fileName: e.fileName});
        setDocumentModal(true)
        retreiveDocuments();
      }} />

      <PreviewBase64 base64={previewBase64.file} fileName={previewBase64.fileName} modal={documentModal} setModal={setDocumentModal} />
      <DocumentImageModal modal={modalDocumentImage} setModal={setModalDocumentImage} documentImage={documentImage} />
    </>
  );
};

const mapStateToProps = (state: IConsultationReduxProps) => ({
  encaissementline: state.encaissementline,
  user: state.user,
  vente: state.vente,
  bien: state.bien,
  auth: state.auth
});

export default connect(mapStateToProps, { getVenteById, clearVenteCard, getBienById, clearBienCard, clearEncaissementLines, getUsers, addContratSigne })(ConsultationContainerComponent);
